export default __webpack_public_path__ + "static/media/image-board-study-now-n-m@2x.ee6fc32f.png";